import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private http: HttpClient) { }

  /**
   * Detecta con IA cuáles de las cláusulas del cliente aparecen en los
   * documentos del contrato. Lee los adjuntos de verdad; si el contrato no
   * tiene documentos legibles devuelve `success: false` con el motivo.
   */
  analyzeContractClauses(obj: { id: number }) {
    return this.http.post(`${environment.apiUrl}/common/ai/contract/clauses`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  /**
   * Consulta con IA sobre un contrato de Gestión de Contratos.
   *
   * NO usa `POST /common/ai`: ese busca el id en `trackvision.requirements`, así
   * que al pasarle el id de un contrato devolvía un informe sobre un
   * requerimiento ajeno que coincidiera en id.
   */
  contractPrompt(obj: { id: number; prompt?: string }) {
    return this.http.post(`${environment.apiUrl}/common/ai/contract`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  generatePrompt(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  askQuestion(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/question`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  analyzeRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/analyze`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  processDocsRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/processDocs`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  syncRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/sync`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  getBackgroundProcess(backgroundprocessid) {
    return this.http.get(`${environment.apiUrl}/common/backgroundprocess/get/${backgroundprocessid}`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
}
